/* eslint-disable max-lines-per-function */

import { ArbeitsbereichMultiSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ArbeitsbereichMultiSelect';
import { ArbeitsbereichSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ArbeitsbereichSelect';
import { ErfahrungslevelSelect } from '@/domain/mitarbeiter/features/anlageassistent/components/ErfahrungslevelSelect';
import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { Body, Heading, Skeleton } from '@e2n/ui/v2';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function Arbeitsbereiche() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const { currentStandort } = useStandortContext();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
        <Body>
          {t(
            'domain.mitarbeiter.create.steps.person.arbeitsbereiche.description',
          )}
        </Body>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <form.AppField name="person.arbeitsbereiche.primaererArbeitsbereich">
          {(field) => (
            <FieldBase
              isRequired
              label={t(
                'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.label',
              )}
              infoText={t(
                `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.info`,
              )}>
              <Suspense fallback={<Skeleton className="w-full h-10" />}>
                <ArbeitsbereichSelect
                  value={field.state.value}
                  handleChange={(value) => {
                    field.handleChange(value);
                    const sekundaereArbeitsbereiche = form.getFieldValue(
                      'person.arbeitsbereiche.sekundaereArbeitsbereiche',
                    );
                    if (sekundaereArbeitsbereiche?.includes(value)) {
                      form.setFieldValue(
                        'person.arbeitsbereiche.sekundaereArbeitsbereiche',
                        sekundaereArbeitsbereiche.filter((ab) => ab !== value),
                      );
                    }
                  }}
                />
              </Suspense>
            </FieldBase>
          )}
        </form.AppField>

        <ErfahrungslevelSelect />

        {currentStandort.qualifikationenEnabled && (
          <form.AppField name="person.arbeitsbereiche.sekundaereArbeitsbereiche">
            {(field) => (
              <FieldBase
                label={t(
                  'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.label',
                )}
                infoText={t(
                  `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.info`,
                )}>
                <Suspense fallback={<Skeleton className="w-full h-10" />}>
                  <form.Subscribe
                    selector={(state) => [
                      state.values.person.arbeitsbereiche
                        .primaererArbeitsbereich,
                    ]}>
                    {([primaererArbeitsbereich]) => (
                      <ArbeitsbereichMultiSelect
                        values={field.state.value}
                        handleChange={(value) => field.handleChange(value)}
                        hideArbeitsbereiche={
                          primaererArbeitsbereich
                            ? [primaererArbeitsbereich]
                            : []
                        }
                      />
                    )}
                  </form.Subscribe>
                </Suspense>
              </FieldBase>
            )}
          </form.AppField>
        )}
      </div>
    </div>
  );
}
